const motorStyle = {
  top: {
    backgroundColor: 'rgb(16, 53, 104)'
  }
};

export default motorStyle;
